module.exports = __webpack_public_path__ + "static/media/slide-1.64564122.jpg";